export default function PortfolioSection() {
  return (
    <section id="portfolio" className="bg-white py-32">
      <div className="max-w-7xl mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl font-bold text-[#2B2D42] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Реализованные проекты
          </h2>
          <div className="w-32 h-0.5 bg-[#D4745E] mx-auto"></div>
        </div>

        {/* Project Card */}
        <div className="flex items-stretch rounded-3xl overflow-hidden shadow-2xl">
          {/* Image */}
          <div className="w-3/5 relative">
            <img
              src="https://public.readdy.ai/ai/img_res/888ef8b9c82e1e4951984211eede7744.jpg"
              alt="Elysium Plaza"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
          </div>

          {/* Content */}
          <div className="w-2/5 bg-[#F7F7F7] p-14 flex flex-col justify-center">
            <div className="inline-block bg-[#F8F4E8] text-[#2B2D42] px-5 py-2.5 rounded-2xl mb-6 self-start">
              <span className="text-xs font-semibold tracking-wider" style={{ fontFamily: 'Montserrat, sans-serif' }}>КОММЕРЧЕСКАЯ НЕДВИЖИМОСТЬ</span>
            </div>

            <h3 className="text-4xl font-bold text-[#2B2D42] mb-4 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
              Бизнес-центр класса «А»<br />Elysium Plaza
            </h3>

            <div className="flex items-center gap-2 text-gray-600 mb-8">
              <i className="ri-map-pin-line text-xl text-[#D4745E]"></i>
              <p className="text-base" style={{ fontFamily: 'Montserrat, sans-serif' }}>г. Харьков, проспект Гагарина</p>
            </div>

            {/* Characteristics */}
            <div className="space-y-4 mb-10">
              <div className="flex items-center gap-3">
                <i className="ri-building-line text-xl text-[#D4745E]"></i>
                <span className="text-sm font-medium text-gray-700" style={{ fontFamily: 'Montserrat, sans-serif' }}>Площадь: 12,500 м²</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-stack-line text-xl text-[#D4745E]"></i>
                <span className="text-sm font-medium text-gray-700" style={{ fontFamily: 'Montserrat, sans-serif' }}>Этажность: 15 этажей</span>
              </div>
              <div className="flex items-center gap-3">
                <i className="ri-calendar-check-line text-xl text-[#D4745E]"></i>
                <span className="text-sm font-medium text-gray-700" style={{ fontFamily: 'Montserrat, sans-serif' }}>Срок реализации: 24 месяца</span>
              </div>
            </div>

            <button className="border-2 border-[#2B2D42] text-[#2B2D42] px-10 py-3.5 rounded-full font-semibold text-sm hover:bg-[#2B2D42] hover:text-white transition-all flex items-center gap-3 group self-start whitespace-nowrap cursor-pointer" style={{ fontFamily: 'Montserrat, sans-serif' }}>
              Смотреть кейс
              <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
